import React from "react";
import { formatFollowUpDate, getFollowUpDisplayStatus } from "../utils/followUp";
import { formatSupportTextForAudience } from "../utils/summary";

export default function SessionFollowUpPanel({
  followUp,
  audience = "self",
  canManage = false,
  readOnly = false,
  onChange,
}) {
  if (!followUp?.nextStepText) return null;
  const displayStatus = getFollowUpDisplayStatus(followUp);
  const memberSafeNextStepText = formatSupportTextForAudience(followUp.nextStepText, audience);

  if (!canManage) {
    return (
      <div className="ui-card" style={{ padding: 12 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
          <strong>Follow-up</strong>
          <span className="nia-pill">{String(displayStatus || followUp.status || "suggested").toUpperCase()}</span>
        </div>
        <div style={{ marginTop: 8 }}>{memberSafeNextStepText}</div>
        {followUp.scheduledFor ? (
          <div className="nia-muted" style={{ marginTop: 8 }}>
            {displayStatus === "scheduled" || displayStatus === "resumed" ? "Scheduled for: " : "Originally scheduled for: "}
            {formatFollowUpDate(followUp.scheduledFor)}
          </div>
        ) : null}
      </div>
    );
  }

  return (
    <div className="ui-card" style={{ padding: 12 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
        <div>
          <strong>Session Follow-up</strong>
          <div className="nia-muted" style={{ marginTop: 4 }}>
            Source: {followUp.suggestedBy === "coach" ? "Coach" : "Nia"}
            {displayStatus === "scheduled" || displayStatus === "resumed"
              ? (followUp.coachConfirmed ? " • Coach confirmed" : " • Scheduled in Nia COACH")
              : (followUp.coachConfirmed ? " • Coach confirmed" : " • Awaiting coach confirmation")}
          </div>
          <div className="nia-muted" style={{ marginTop: 4 }}>
            Created by {followUp.createdByType === "coach" ? "coach" : "Nia"}
            {followUp.updatedByType ? ` • Last updated by ${followUp.updatedByType === "coach" ? "coach" : "Nia"}` : ""}
          </div>
        </div>
        <span className="nia-pill">{String(displayStatus || followUp.status || "suggested").toUpperCase()}</span>
      </div>

      <div style={{ display: "grid", gap: 10, marginTop: 10 }}>
        <div>
          <label>Next step</label>
          <textarea
            rows={3}
            value={followUp.nextStepText}
            onChange={(e) => onChange?.({ nextStepText: e.target.value, suggestedBy: "coach" })}
            disabled={readOnly}
          />
        </div>
        <div>
          <label>Follow-up note</label>
          <textarea
            rows={3}
            value={followUp.note || ""}
            onChange={(e) => onChange?.({ note: e.target.value })}
            disabled={readOnly}
          />
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 10, alignItems: "end" }}>
          <div>
            <label>Status</label>
            <select
              value={followUp.status || "suggested"}
              onChange={(e) => onChange?.({ status: e.target.value })}
              disabled={readOnly}
            >
              <option value="suggested">Suggested</option>
              <option value="scheduled">Scheduled</option>
              <option value="completed">Completed</option>
              <option value="dismissed">Dismissed</option>
            </select>
          </div>
          <button
            type="button"
            className="btn btn-ghost"
            onClick={() => onChange?.({ coachConfirmed: true })}
            disabled={readOnly || followUp.coachConfirmed}
          >
            {followUp.coachConfirmed ? "Confirmed" : "Confirm next step"}
          </button>
        </div>
        {followUp.scheduledFor ? (
          <div className="nia-muted">
            {displayStatus === "scheduled" || displayStatus === "resumed" ? "Scheduled for: " : "Originally scheduled for: "}
            {formatFollowUpDate(followUp.scheduledFor)}
          </div>
        ) : null}
      </div>
    </div>
  );
}
